import { z } from 'zod';
import { createZodDto } from 'nestjs-zod';

export const deviceStatus = z.object({
  isAvailable: z.boolean(),
  secondsSinceLastPing: z.number().nullable(),
});

export class DeviceStatus extends createZodDto(deviceStatus) {}
